import { Navigate, type RouteObject, useParams } from "react-router-dom";
import { Layout } from "./layout/Layout";
import { RequireSession } from "./RequireSession";
import { HomePage } from "@/features/home/HomePage";
import { PeoplePage } from "@/features/people/PeoplePage";
import { ContactPage } from "@/features/contact/ContactPage";
import { ContactEditPage } from "@/features/contact/ContactEditPage";
import { GroupPage } from "@/features/groups/GroupPage";
import { NewGroupPage } from "@/features/groups/NewGroupPage";
import { NotesPage } from "@/features/notes/NotesPage";
import { RemindersPage } from "@/features/reminders/RemindersPage";
import { DuplicatesPage } from "@/features/duplicates/DuplicatesPage";
import { MapPage } from "@/features/map/MapPage";
import { SearchPage } from "@/features/search/SearchPage";
import { ArchivePage } from "@/features/archive/ArchivePage";
import { SettingsPage } from "@/features/settings/SettingsPage";
import { OnboardingPage } from "@/features/onboarding/OnboardingPage";
import { InvitePage } from "@/features/invite/InvitePage";
import { AdminPage } from "@/features/admin/AdminPage";
import { networkRoutes } from "@/features/network";
import { EmptyState } from "@/ui";

function LegacyContactForm() {
  const { id } = useParams();
  return <Navigate to={`/contact/${id}/edit`} replace />;
}

export const routes: RouteObject[] = [
  { path: "/onboarding", element: <OnboardingPage /> },
  {
    path: "/",
    element: (
      <RequireSession>
        <Layout />
      </RequireSession>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: "people", element: <PeoplePage /> },
      { path: "people/new", element: <ContactEditPage mode="create" /> },
      { path: "people/duplicates", element: <DuplicatesPage /> },
      { path: "people/map", element: <MapPage /> },
      { path: "contact/:id", element: <ContactPage /> },
      { path: "contact/:id/edit", element: <ContactEditPage mode="edit" /> },
      { path: "contact/:id/form", element: <LegacyContactForm /> },
      { path: "group/new", element: <NewGroupPage /> },
      { path: "group/create", element: <Navigate to="/group/new" replace /> },
      { path: "group/:id", element: <GroupPage /> },
      { path: "group/:id/highlights", element: <GroupPage tab="highlights" /> },
      { path: "notes", element: <NotesPage /> },
      { path: "reminders", element: <RemindersPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "archive", element: <ArchivePage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "settings/:section", element: <SettingsPage /> },
      { path: "invite/:token", element: <InvitePage /> },
      { path: "admin", element: <AdminPage /> },
      { path: "admin/:tab", element: <AdminPage /> },
      ...networkRoutes,
      { path: "*", element: <EmptyState title="There is nothing at this address">Use the sidebar or the command bar to get back on track.</EmptyState> },
    ],
  },
];
